var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app_intro"},[_c('h2',[_vm._v("What you'll need:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Farm size and address")]),_vm._v(" "),_c('li',[_vm._v("Farm ownership/operation details")]),_vm._v(" "),_c('li',[_vm._v("Farm financials")]),_vm._v(" "),_c('li',[_vm._v("Personal information")])])])
}]

export { render, staticRenderFns }